module.exports = __webpack_public_path__ + "img/dizzy_ios_802.png";